module.exports = __webpack_public_path__ + "static/media/file-minus.0ce11b3e.svg";